/**
 * 请求的基本能用封装
 */
import axios from 'axios';

const pending = [];
export const cancelPending = (pendingList,config) => {
  pendingList.forEach((item, index) => {
    if (config) {
      if (item.u === config.url) {
        item.f() // 取消请求
        pendingList.splice(index, 1) // 移除当前请求记录
      }
    } else {
      item.f() // 取消请求
      pendingList.splice(index, 1) // 移除当前请求记录
    }
  })
}

// 封闭请求
const instance = axios.create({
  // 使用domain name作为baseURL，因为：
  // 1. 后台API服务的SSL基于legallink.info域名。2. 这样可以避免跨域问题。
  // 本地开发时，可以通过修改hosts文件来指向本地API服务，或者nginx可以通过反向代理来指向本地API服务。
  baseURL: 'https://legallink.info:9001',
  timeout: 30000,
});

// 封闭请求
export const instanceServerTest = axios.create({
  baseURL: 'https://legallink.info:8085',
  timeout: 30000,
});

// 封闭请求
export const instanceServerProd = axios.create({
  baseURL: 'https://legallink.info:8086',
  timeout: 30000,
});

export const instanceServer =
  process.env.NODE_ENV === 'development' || process.env.REACT_APP_BUILD_ENV === 'dev'
    ? instanceServerTest
    : instanceServerProd;

[instance, instanceServerTest, instanceServerProd].forEach((instance) => {

// 添加响应拦截器
  instance.interceptors.response.use(
    response => {
      cancelPending(pending, response.config)
      /**
       * code为非0是抛错 可结合自己业务进行修改
       */
      const res = response.data || {};
      const { RetCode, Data, Message } = res;
      // token 无效 或者 token 过期

      if (RetCode && RetCode !== 0 && RetCode !== 1100005) {
        let errorMessage;
        switch (RetCode) {
          case -1:
            errorMessage = '服务端错误->' + Message;
            break;
          default:
            errorMessage = RetCode+ ':' + Message;
            break;
        }
        if (response?.config?.params?.TrackSN) {
          errorMessage = errorMessage + '(' + response.config.params.TrackSN + ')';
        }
        const errorObject = { code: RetCode, message: errorMessage };
        console.error(errorObject);
        return Promise.reject(errorObject)
      } else if(Data){
        return Data
      } else {
        return response.data
      }
    },
    error => {
      if (!error.response) {
        return Promise.reject(error)
      }
      if (error.response?.config?.method === 'get' && (error.response.status === 404 || error.response.status === 415)) {
        return Promise.reject(error)
      } else {
        return Promise.reject(error)
      }
    }
  )

});
export default instance;
